import {gql} from '@apollo/client'

export const GET_MY_CONTACT_FILTERS = gql`
  query myContactFilters {
    myContactFilters {
      id
      name
      filters
      created
      updated
    }
  }
`
